import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import S12nSubscriptionPropBulletPoints from 'bundles/enroll-modal/components/s12n-subscriptions/free-trialV2/S12nSubscriptionPropBulletPoints';
import S12nSubscriptionVPropCDPFreeTrial from 'bundles/enroll-modal/components/s12n-subscriptions/free-trialV2/S12nSubscriptionVPropCDPFreeTrial';
import { freeTrial } from 'bundles/payments-common/common/constants';

import _t from 'i18n!nls/enroll';

import 'css!./__styles__/SubscriptionVPropFreeTrial';

type PropsFromCaller = {
  onSdp: boolean;
};

const S12nSubscriptionVPropFreeTrial = ({ onSdp }: PropsFromCaller) => {
  return (
    <div className="rc-SubscriptionVPropFreeTrial">
      <h2 className="headline-5-text punch-line">
        <FormattedMessage message={_t('{numDays}-day Free Trial')} numDays={freeTrial.numDays} />
      </h2>
      {!onSdp && <S12nSubscriptionVPropCDPFreeTrial />}

      <S12nSubscriptionPropBulletPoints />
    </div>
  );
};

export default S12nSubscriptionVPropFreeTrial;
